import { sva } from '~/styled-system/css'
import { hstack } from '~/styled-system/patterns'
import { Button } from '~/ui'
import { FixedPointText } from '../../plan/PlanDetail'
import RequestReservationLabel from '../../plan/RequestReservationLabel'
import { RESERVE_LABEL } from '../sd/label'
import type { SeatOnlyCourseProps } from '../type'

const styles = sva({
  slots: ['root', 'heading', 'label', 'labelTitle', 'labelSubtitle', 'appeal', 'button'],
  base: {
    root: hstack.raw({
      justify: 'space-between',
      rounded: 'md',
      border: 'medium',
      backgroundColor: 'white',
      padding: '4',
      w: 'full',
    }),
    heading: {
      spaceY: '1',
    },
    label: hstack.raw({
      gap: '1',
    }),
    labelTitle: {
      fontSize: 'xl',
      fontWeight: 'bold',
    },
    labelSubtitle: {
      fontSize: 'sm',
      color: 'gray.700',
    },
    appeal: hstack.raw({
      gap: '3',
    }),
    button: {
      paddingX: '4',
      paddingY: '3',
    },
  },
})

export function SeatOnlyCourse({
  onClick,
  onlyRequestReservations,
  fixedPoints,
}: SeatOnlyCourseProps) {
  const classes = styles()
  return (
    <div className={classes.root}>
      <div className={classes.heading}>
        {onlyRequestReservations && <RequestReservationLabel />}
        <p className={classes.label}>
          <span className={classes.labelTitle}>席の予約</span>
          <span className={classes.labelSubtitle}>（食事は当日にご注文）</span>
        </p>
      </div>
      <div className={classes.appeal}>
        <FixedPointText fixedPoints={fixedPoints} />
        <Button onClick={onClick} color="secondarySolid" size="sm" className={classes.button}>
          {RESERVE_LABEL}
        </Button>
      </div>
    </div>
  )
}
